/** Default off; only the exact tenant row can enable changes/closeout. */
export const ROSTER_CHANGES_FLAG = 'roster_changes_v1';
export function isTenantScopedRosterChangesFlag(key: string | null | undefined): boolean {
  return key === ROSTER_CHANGES_FLAG;
}
